import { defineStore } from "pinia";
import { getActivePinia } from "pinia";
import { handleError } from "../helpers/helpers";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
const apiGatewayRepository = RepositoryFactory.get("apiGateway");
import router from "@/router";
import ApplicationError from "@/helpers/applicationError";
import Logger from "@/helpers/logger";
import {API_RESPONSE_SUCCESS, BAD_REQUEST_ERROR_CODE, SUCCESS_CODE} from "@/data/constants";
import axios from "axios";

export const useSessionStore = defineStore("alerts", {
    id: "session",
    state: () => {
        return {
            step: "login",
            HVCHUBSYNCHSSID: "",
            auth_id: "",
            email: "",
            password: "",
            telError: false,
            session_data: {},
            loginErrors: {},
            loginErrorMsg: null,
            isLoading: false,
        };
    },
    persist: {
        paths: ["session_data"],
    },
    getters: {
        getSessionData(state) {
            let data = {};
            if (
                typeof state.settlementResponseData.product_info_list !== "undefined"
            ) {
                data = state.settlementResponseData.product_info_list;
            }
            return data;
        },
    },
    actions: {
        async logIn() {
            try {
                this.isLoading = true;
                this.loginErrorMsg = null;

                const sessionData = await apiGatewayRepository.login(
                    this.email,
                    this.password
                );
                this.session_data = sessionData.data;
                this.storeSession(
                    this.session_data.HVCHUBSYNCHSSID,
                    this.session_data.auth_id,
                    this.session_data.hubsynch_id
                );
                return true;
            } catch (error) {
                this.isLoading = false;
                Logger.captureMessage(error.message);
                
                if(error.response.data && error.response.data.errors){
                    const data = error.response.data;
                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "object") {
                        this.loginErrors = data.errors;
                    }

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "string") {
                        if(data.errors == "ログインIDかパスワードが正しくないか、リクエストパラメータの値が正しくありません。REST API外部インターフェース仕様書を確認してください。"){
                            this.loginErrorMsg = "ログインに失敗しました、メールアドレスとパスワードをご確認ください";
                        } else {
                            this.loginErrorMsg = data.errors;
                        }
                    }
                }
            }
            return false;
        },
        async logOut() {
            try {
                this.isLoading = true;
                const response = await apiGatewayRepository.logout();
                this.isLoading = false;
                if (response.data != null && response.data.result == API_RESPONSE_SUCCESS) {
                    this.clearSession();
                    return true;
                } else {
                    return false;
                }
            } catch (error) {
                Logger.captureMessage(error.message);
                return false;
            }
        },
        async resetPassword() {
            try {
                this.isLoading = true;

                let url =
                    process.env.VUE_APP_API_URL +
                    process.env.VUE_APP_CONSUMER_PASSWORD_REMINDER;
                let passwordFormData = this.getResetPasswordData;

                let isValidated = this.validateResetPassword(passwordFormData);
                if (!isValidated) {
                    this.isLoading = false;
                    return false;
                }

                let requestData = {
                    email: passwordFormData.email,
                    birthday: `${passwordFormData.year}-${passwordFormData.month}-${passwordFormData.day}`,
                };

                await axios.post(url, requestData).then(async (r) => {
                    const data = r.data;
                    if (data.success === API_RESPONSE_SUCCESS && data.code === SUCCESS_CODE) {
                        await router.push({ name: "reminder.complete" });
                    }
                });
            } catch (e) {
                this.isLoading = false;
                throw new ApplicationError(e.message, {}, e);
            }
            this.isLoading = false;
        },
        storeSession(ssid, authId, hubsynchId) {
            window.localStorage.setItem("HVCHUBSYNCHSSID", ssid);
            window.localStorage.setItem("auth_id", authId);
            window.localStorage.setItem("hubsynch_id", hubsynchId);
        },
        getSession() {
            const ssid = window.localStorage.getItem("HVCHUBSYNCHSSID");
            const auth_id = window.localStorage.getItem("auth_id");

            return {
                ssid: ssid,
                auth_id: auth_id,
            };
        },
        isLoggedIn(){
            const session = this.getSession();
            return session.ssid !== null && session.auth_id !== null && session.ssid !== "" && session.auth_id !== "";
        },
        clearSession() {
            window.localStorage.clear();
            getActivePinia()._s.forEach((store) => store.$reset());
        },
    },
});
